const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriversR(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M228.291 243.089c-13.607 0-24.686 11.063-24.686 24.662 0 13.599 11.079 24.67 24.686 24.67 13.599 0 24.678-11.071 24.678-24.67 0-13.599-11.079-24.662-24.678-24.662Z",
    style: {
      fill: "rgb(45, 169, 226)",
      fillRule: "nonzero"
    },
    transform: "matrix(.046 0 0 .046 .5 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.207 278.961c28.523-33.148 71.775-50.226 128.407-51.015-.374-18.899-3.528-37.115-9.096-54.258-61.037 40.838-121.091 54.657-174.236 54.657-93.844 0-166.107-42.805-184.25-54.616-5.34 16.477-8.372 33.986-8.95 52.096 58.664.008 103.209 17.233 132.406 51.161 46.081 53.567 38.521 129.992 36.961 142.242 6.202.61 12.477.943 18.842.943 7.665 0 15.241-.52 22.687-1.414-1.927-17.665-6.495-89.001 37.229-139.796Zm107.143-79.969 3.121 7.259-59.647 25.646-3.129-7.243 59.655-25.662Zm-273.47 32.904L62.232 206.25l3.113-7.259 59.639 25.662-3.104 7.243Zm73.84 35.855c0-17.956 14.599-32.563 32.571-32.563 17.956 0 32.571 14.607 32.571 32.563 0 17.964-14.615 32.571-32.571 32.571-17.972 0-32.571-14.607-32.571-32.571Z",
    style: {
      fill: "rgb(45, 169, 226)",
      fillRule: "nonzero"
    },
    transform: "matrix(.046 0 0 .046 .5 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.283.004C102.412.004 0 102.408 0 228.279c0 125.879 102.412 228.283 228.283 228.283 125.871 0 228.283-102.412 228.283-228.283C456.566 102.408 354.154.004 228.283.004Zm0 428.051c-108.248 0-196.329-88.057-196.329-196.313 0-108.256 88.081-196.33 196.329-196.33 108.24 0 196.313 88.065 196.313 196.321s-88.073 196.322-196.313 196.322Z",
    style: {
      fill: "rgb(45, 169, 226)",
      fillRule: "nonzero"
    },
    transform: "matrix(.046 0 0 .046 .5 .5)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriversR);
export default __webpack_public_path__ + "static/media/drivers-r.26d645d9b3feaa9e1a66d06d8e51e82f.svg";
export { ForwardRef as ReactComponent };